import cx from "classnames";
import { ReactNode } from "react";

import { Text } from "@/components/elements/Text";

import styles from "./styles.module.css";

type CardUiInfoBlockProps = {
  topLeft?: ReactNode;
  topRight?: ReactNode;
  bottomLeft?: ReactNode;
  bottomRight?: ReactNode;
  className?: string;
};

const CardUiInfoBlock = ({
  topLeft,
  topRight,
  bottomLeft,
  bottomRight,
  className = "",
}: CardUiInfoBlockProps) => {
  return (
    <div className={cx(className, styles.infoContainer)}>
      <div className={styles.titlePrice}>
        <Text as="div">{topLeft}</Text>
        <Text as="div">{topRight}</Text>
      </div>
      <div className={styles.brandSize}>
        <Text as="div" size="xs" className={styles.brand}>
          {bottomLeft}
        </Text>
        <Text as="div" size="xs">
          {bottomRight}
        </Text>
      </div>
    </div>
  );
};

export default CardUiInfoBlock;
